import Vue from 'vue';
import * as common from '../common.js'
import * as calendarCommon from '../calendar-common.js'
import flatpickr from 'flatpickr';
import English from 'flatpickr/dist/l10n/default';
import { Japanese } from 'flatpickr/dist/l10n/ja';
import { Korean } from 'flatpickr/dist/l10n/ko';
import { Mandarin } from 'flatpickr/dist/l10n/zh';
import { MandarinTraditional } from 'flatpickr/dist/l10n/zh-tw';
import Swiper from "swiper/swiper-bundle.esm.js";
import "swiper/swiper-bundle.min.css";
import moment from 'moment'
import VueSmoothScroll from 'vue-smoothscroll'
import {
    couponBanner,
    couponBannerModal,
    couponBadgeBanner,
    couponBadgeModal,
} from './coupon.js'

// flatpicker settings.
[Japanese, English, Mandarin, MandarinTraditional, Korean].forEach(l => l.rangeSeparator = ' - ');
Mandarin.weekdays.shorthand = ['日', '一', '二', '三', '四', '五', '六'];
MandarinTraditional.weekdays.shorthand = ['日', '一', '二', '三', '四', '五', '六'];

const FLATPICKER_LANGUAGES = {
    ja: Japanese,
    en: English,
    'zh-CN': Mandarin,
    'zh-TW': MandarinTraditional,
    ko: Korean,
};

const SORT_MAP = {
    RECOMMENDED: '0',
    LOWEST_PRICE: '1',
    HIGHEST_PRICE: '2',
};

const DAY_OF_WEEK_MAP = {
    0: $t("common.calendar.sunday.short"),
    1: $t("common.calendar.monday.short"),
    2: $t("common.calendar.tuesday.short"),
    3: $t("common.calendar.wednesday.short"),
    4: $t("common.calendar.thursday.short"),
    5: $t("common.calendar.friday.short"),
    6: $t("common.calendar.saturday.short"),
}

const DISPLAY_DAYS_TOTAL_COUNT = 7;
const DISPLAY_DAYS_MIDDLE_COUNT = 4;

const TODAY = moment().startOf('day');
const ONE_YEAR_LATER = moment().add(1, 'year').startOf('day');

Vue.use(VueSmoothScroll);

let holidaysData;

window.addEventListener('DOMContentLoaded', async () => {
    holidaysData = await calendarCommon.getHolidaysData();
    new Vue(mainComponent);
})

const mainComponent = {
    el: '#mainContents',
    data() {
        const initialData = getInitialData();

        const searchConditions = {
            hotelCode: initialData.hotelCode,
            checkInDate: initialData.checkInDate ? initialData.checkInDate : moment().format('YYYY-MM-DD'),
            selectedLodgerType: initialData.selectedLodgerType, // ex. 0_1_3 → 大人_子どもA_子どもC
            selectedLodgerCount: initialData.selectedLodgerCount, // ex. 2_1_0 → 大人2名_子どもA1名_子どもC0名
            sortKeyOrder: initialData.sortKeyOrder ? initialData.sortKeyOrder : 'RECOMMENDED',
            ghaLanding: initialData.ghaLanding,
        }

        // 宿泊者タイプコードと人数のパラメータの長さが同じか
        let isSelectedLodgerTypeCountValid = false;
        if (searchConditions.selectedLodgerType && searchConditions.selectedLodgerCount) {
            const typeList = searchConditions.selectedLodgerType.split('_');
            const countList = searchConditions.selectedLodgerCount.split('_');
            isSelectedLodgerTypeCountValid = typeList.length == countList.length;
        }

        // 宿泊者タイプコードと人数のパラメータ指定が無いorどちらか無いor両者の長さが異なる場合は、デフォルトの値（施設設定による選択可能な最少人数）を入れる
        if (!searchConditions.selectedLodgerType || !searchConditions.selectedLodgerCount || !isSelectedLodgerTypeCountValid) {
            const lodgerTypeCodeList = initialData.lodgerTypeInfoList.map(lodgerTypeInfo => {
                return lodgerTypeInfo.lodgerTypeCode;
            })

            const lodgingPossibleNumMinList = initialData.lodgerTypeInfoList.map(lodgerTypeInfo => {
                return lodgerTypeInfo.lodgingPossibleNumMin;
            })

            //大人だけは、施設が設定した検索初期人数の値を入れる
            const lodgerCountList = lodgingPossibleNumMinList;
            if (initialData.searchDefaultLodgerCounts && initialData.searchDefaultLodgerCounts.length > 0) {
                if (initialData.lodgerTypeInfoList[0].lodgingPossibleNumMin <= initialData.searchDefaultLodgerCounts[0] && initialData.searchDefaultLodgerCounts[0] <= initialData.lodgerTypeInfoList[0].lodgingPossibleNumMax) {
                    lodgerCountList[0] = initialData.searchDefaultLodgerCounts[0];
                }
            }

            searchConditions.selectedLodgerType = lodgerTypeCodeList.join('_');
            searchConditions.selectedLodgerCount = lodgerCountList.join('_');
        }

        // keyが宿泊者タイプコード、valueが選択された人数のオブジェクトを作成 ex. {0:2, 1:1, 3:0} → 大人2名_子どもA1名_子どもC0名
        const lodgerTypeList = searchConditions.selectedLodgerType.split('_');
        const lodgerCountList = searchConditions.selectedLodgerCount.split('_').map(str => parseInt(str, 10));
        const selectedLodgerTypeCount = lodgerCountList.reduce((accumulator, currentValue, index) => {
          accumulator[lodgerTypeList[index]] = currentValue;
          return accumulator;
        }, {});

        return {
            lodgerTypeInfoList: initialData.lodgerTypeInfoList,
            hotelNotice: initialData.hotelNotice,
            memberUseFlag: initialData.memberUseFlag,
            couponBanner: initialData.couponBanner,
            coupons: initialData.coupons,

            searchConditions: searchConditions,
            savedCheckInDate: searchConditions.checkInDate,
            selectedLodgerTypeCount: selectedLodgerTypeCount,
            selectedLodgerTotalCount: undefined,
            displayDays: [],

            roomList: [],
            roomListOrder: [],
            sortedRoomList: [],

            isLoading: true,
            isRoomDetailModalOpened: false,
            eachRoomDetail: {},
            isGuestsSelectModalOpened: false,
            isHotelNoticeLong: false, //「施設からのお知らせ」が折り畳み必要な長さか
            isHotelNoticeOpened: false, // 「施設からのお知らせ」が畳まれているか展開されているか
            isRequestParamInvalid: true,  //リクエストパラメーターに違反があるか
            isFindRoomListFailed: false, // 部屋取得に失敗したか
        }
    },
    i18n: window.i18n,
    computed: {
        flatpickr() {
            return this.$refs.flatpickr._flatpickr;
        },
        isShiftBackwardActive() {
            const minDisplayDate = moment(this.displayDays[0], 'YYYY-MM-DD');
            return minDisplayDate.isAfter(TODAY);
        },
        isShiftForwardActive() {
            const maxDisplayDate = moment(this.displayDays[DISPLAY_DAYS_TOTAL_COUNT - 1], 'YYYY-MM-DD');
            return maxDisplayDate.isBefore(ONE_YEAR_LATER);
        },
    },
    mounted() {
        if (this.hotelNotice) {
            const hotelNotice = document.getElementById('hotelNotice');
            if (hotelNotice.clientHeight > 70) {
                this.isHotelNoticeLong = true;
                hotelNotice.classList.add("long");
                hotelNotice.classList.add("shortDetails");
            }
        }

        this.initFlatpickr();

        window.addEventListener('popstate', event => {
            window.location.reload();
        });

        this.setSelectedLodgerTotalCount();

        this.search();
    },
    components: {
        couponBanner,
        couponBannerModal,
        couponBadgeBanner,
        couponBadgeModal,
    },
    methods: {
        $t: window.$t,
        initFlatpickr() {
            const padZero = function(n, targetLength) {
                return n.toString().padStart(targetLength, 0);
            }

            const onDayCreate = (o, s, fp, dayElement) => {
                let className;

                const dayOfWeek = dayElement.dateObj.getDay();
                if (dayOfWeek == 0) {
                    className = 'sunday';
                } else if (dayOfWeek == 6) {
                    className = 'saturday';
                }

                // check holiday.
                const d = dayElement.dateObj;
                const date = `${padZero(d.getFullYear(), 4)}-${padZero(d.getMonth() + 1, 2)}-${padZero(d.getDate(), 2)}`;
                if (date in holidaysData) {
                    className = 'holiday';
                }

                if (className) {
                    dayElement.classList.add(className);
                }
            };

            const defaultDate = this.searchConditions.checkInDate ?
                    moment(this.searchConditions.checkInDate, 'YYYYMMDD').toDate() : moment().toDate();

            const fp = flatpickr(this.$refs.flatpickr, {
                locale : FLATPICKER_LANGUAGES[$currentLanguage] || Japanese,
                mode: 'single',
                dateFormat : 'Y/m/d (D)',
                defaultDate : defaultDate,
                minDate: moment(0, "H").toDate(),
                disableMobile: true,
                onDayCreate,
            });

            // 選ばれたチェックイン日に合わせて販売状況表示期間を更新
            fp.config.onChange.push((selectedDates, dateStr, instance) => {
                const dates = selectedDates;
                this.savedCheckInDate = moment(dates[0]).format('YYYY-MM-DD');
            })
        },
        availableLodgerNumRange(min, max) { // 施設設定による選択可能な人数の範囲を返す
                let availableLodgerNumRange = [];
                for (let i = min; i <= max; i++) {
                    availableLodgerNumRange.push(i);
                }
                return availableLodgerNumRange;
        },
        openHotelNotice() {
            this.isHotelNoticeOpened = true;
            const hotelNotice = document.getElementById('hotelNotice');
            hotelNotice.classList.remove("long", "shortDetails");
            hotelNotice.classList.add("longDetails");
        },
        closeHotelNotice() {
            this.isHotelNoticeOpened = false;
            const hotelNotice = document.getElementById('hotelNotice');
            hotelNotice.classList.remove("longDetails");
            hotelNotice.classList.add("long", "shortDetails");
        },
        selectDate() {
            this.flatpickr.open();
        },
        setSelectedLodgerCount() { // 検索する宿泊者タイプ別人数を更新、検索
            let lodgerCountList = Object.values(this.selectedLodgerTypeCount);
            this.searchConditions.selectedLodgerCount = lodgerCountList.join('_');

            this.setSelectedLodgerTotalCount();
            this.isGuestsSelectModalOpened = false;
            this.doSearch();
        },
        setSelectedLodgerTotalCount() {
            let lodgersCount = Object.values(this.selectedLodgerTypeCount).map(str => parseInt(str, 10));
            this.selectedLodgerTotalCount = lodgersCount.reduce((a, b) => {
                return a + b;
            });
        },
        async doSearch() {
            this.searchConditions.checkInDate = this.savedCheckInDate;
            await this.search();
            this.addBrowserHistory();
            this.isRequestParamInvalid = false;

            if (this.couponBanner && !this.couponBanner.errorMessage && this.couponBanner.available) {
                const currentUrl = new URL(window.location.href);
                const params = currentUrl.search;
                const myHeaders = new Headers();
                const acceptLanguage = $currentLanguage.replace('_','-');
                myHeaders.append('Accept-Language', acceptLanguage);
                const couponUrl = `${window.$contextPath}${window.$contextPath.endsWith('/') ? '' : '/'}api/coupons/reassign/calendar${params}`;
                const response = await await fetch(couponUrl, {method:'GET', headers: myHeaders});
                const res = await response.json();
                if (res) {
                    this.$set(this.couponBanner, 'coupons', res.coupons);
                }
            }
        },
        async search() {
            this.setDisplayDays();
            await this.findRoomList();
            this.sortRoomListBySortKeyOrder();
        },
        async findRoomList() { //部屋情報取得 ページ初期化時、検索ボタン押下時、左右に期間を移動させた時(月跨ぎで必要があれば)
            try {
                this.isLoading = true;
                this.isFindRoomListFailed = false;
                const parameters = new URLSearchParams();
                parameters.append('fromYM', moment(this.displayDays[0], 'YYYY-MM-DD').format('YYYYMM'));
                parameters.append('toYM', moment(this.displayDays[DISPLAY_DAYS_TOTAL_COUNT - 1], 'YYYY-MM-DD').format('YYYYMM'));
                parameters.append('lodgerCode', this.searchConditions.selectedLodgerType);
                parameters.append('lodgerNum', this.searchConditions.selectedLodgerCount);
                parameters.append('onlyAllLanguagesPlan', this.searchConditions.ghaLanding);
                parameters.append('onlyAllRankPlan', this.searchConditions.ghaLanding);
                const url = '/v1/search/hotels/' + this.searchConditions.hotelCode + '/calendar?' + parameters.toString();
                const myHeaders = new Headers();
                const acceptLanguage = $currentLanguage.replace('_','-');
                myHeaders.append('Accept-Language', acceptLanguage);
                const response = await fetch(url, {method:'GET', headers: myHeaders});
                const responseJson = await response.json();
                this.roomList = responseJson.data;
                this.filterSalesStatusList();
            } catch {
               this.isFindRoomListFailed = true;
            } finally {
                this.isLoading = false;
            }
        },
        filterSalesStatusList() { // 表示する期間の販売状況リストを返す
            this.roomList.forEach(room => {
                let filteredSalesStatusList = [];
                this.displayDays.forEach(displayDate =>
                    filteredSalesStatusList.push(room.dailySalesStatusList.find(eachDaySalesStatus =>
                        eachDaySalesStatus.salesDate == displayDate)));

                filteredSalesStatusList.forEach(day => {
                    if (day.lowestPlanForMember && day.lowestPlanForMember.totalPrice) {
                        day.lowestPlanForMember.displayTotalPrice = day.lowestPlanForMember.totalPrice.toLocaleString();
                    }
                    if (day.lowestPlanForRegular && day.lowestPlanForRegular.totalPrice) {
                        day.lowestPlanForRegular.displayTotalPrice = day.lowestPlanForRegular.totalPrice.toLocaleString();
                    }
                });

                room.filteredSalesStatusList = filteredSalesStatusList;
            });
        },
        sortRoomListBySortKeyOrder() { //部屋の並び替え ページ初期化時、検索ボタン押下時
            switch(this.searchConditions.sortKeyOrder) {
                case 'RECOMMENDED':
                    this.roomList.sort((a,b) => a.recommendedOrder - b.recommendedOrder);
                    break;
                case 'LOWEST_PRICE':
                    let lowestPriceA;
                    let lowestPriceB;
                    this.roomList.sort((a,b) => {
                        const referenceDateA = a.dailySalesStatusList.find(day => day.salesDate == this.searchConditions.checkInDate);
                        const referenceDateB = b.dailySalesStatusList.find(day => day.salesDate == this.searchConditions.checkInDate);

                        //準備中の場合は後ろに回す
                        if (referenceDateA.stockStatus == 'NO_SALE') {
                            return 1;
                        }
                        if (referenceDateB.stockStatus == 'NO_SALE') {
                            return -1;
                        }

                        //会員価格設定なしの場合は通常価格で並び替え
                        if (referenceDateA.lowestPlanForMember && referenceDateA.lowestPlanForMember.totalPrice) {
                            lowestPriceA = referenceDateA.lowestPlanForMember.totalPrice;
                        } else {
                            lowestPriceA = referenceDateA.lowestPlanForRegular.totalPrice;
                        }
                        if (referenceDateB.lowestPlanForMember && referenceDateB.lowestPlanForMember.totalPrice) {
                            lowestPriceB = referenceDateB.lowestPlanForMember.totalPrice;
                        } else {
                            lowestPriceB = referenceDateB.lowestPlanForRegular.totalPrice;
                        }

                        return lowestPriceA - lowestPriceB;
                    });
                    break;
                case 'HIGHEST_PRICE':
                    let highestPriceA;
                    let highestPriceB;
                    this.roomList.sort((a,b) => {
                        const referenceDateA = a.dailySalesStatusList.find(day => day.salesDate == this.searchConditions.checkInDate);
                        const referenceDateB = b.dailySalesStatusList.find(day => day.salesDate == this.searchConditions.checkInDate);

                        //準備中の場合は後ろに回す
                        if (referenceDateA.stockStatus == 'NO_SALE') {
                            return 1;
                        }
                        if (referenceDateB.stockStatus == 'NO_SALE') {
                            return -1;
                        }

                        //会員価格設定なしの場合は通常価格で並び替え
                        if (referenceDateA.lowestPlanForMember && referenceDateA.lowestPlanForMember.totalPrice) {
                            highestPriceA = referenceDateA.lowestPlanForMember.totalPrice;
                        } else {
                            highestPriceA = referenceDateA.lowestPlanForRegular.totalPrice;
                        }
                        if (referenceDateB.lowestPlanForMember && referenceDateB.lowestPlanForMember.totalPrice) {
                            highestPriceB = referenceDateB.lowestPlanForMember.totalPrice;
                        } else {
                            highestPriceB = referenceDateB.lowestPlanForRegular.totalPrice;
                        }

                        return highestPriceB - highestPriceA;
                    });
                    break;
                default:
            }

            this.sortedRoomList = this.roomList;
            this.roomListOrder = this.roomList.map(room => room.code);
        },
        sortRoomListByCurrentOrder() { //部屋の並び替え 表示期間移動時
            const roomMap = {};
            this.roomList.forEach(room => roomMap[room.code] = room)

            this.sortedRoomList = this.roomListOrder.map(roomCode => roomMap[roomCode])
        },
        setDisplayDays() { //表示する期間の日にちの配列を作る 初期表示時、検索ボタン押下時
            const checkInDate = this.searchConditions.checkInDate ?
                moment(this.searchConditions.checkInDate, 'YYYY-MM-DD') : moment();
            const startDate = checkInDate.subtract(DISPLAY_DAYS_MIDDLE_COUNT - 1, 'days'); //チェックイン日を真ん中にする

            this.displayDays = [];
            this.displayDays.push(startDate.format('YYYY-MM-DD'));
            while (this.displayDays.length < DISPLAY_DAYS_TOTAL_COUNT) {
                this.displayDays.push(checkInDate.add(1, 'days').format('YYYY-MM-DD'));
            }
        },
        async shiftDisplayDays(direction) { //表示する期間の日にちの配列を作る 左右に期間を移動させた時
            let startDate = undefined;
            if (direction == 'forward') {
                startDate = moment(this.displayDays[DISPLAY_DAYS_TOTAL_COUNT - 1], 'YYYY-MM-DD').add(1, 'days')
            }
            if (direction == 'backward') {
                startDate = moment(this.displayDays[0], 'YYYY-MM-DD').subtract(DISPLAY_DAYS_TOTAL_COUNT, 'days')
            }

            this.displayDays = [];
            this.displayDays.push(startDate.format('YYYY-MM-DD'));
            while (this.displayDays.length < DISPLAY_DAYS_TOTAL_COUNT) {
                this.displayDays.push(startDate.add(1, 'days').format('YYYY-MM-DD'));
            }

            //表示したい期間の部屋データを持っていない場合は部屋取得しにいく
            const minDisplayDate = this.displayDays[0];
            const maxDisplayDate = this.displayDays[DISPLAY_DAYS_TOTAL_COUNT - 1];
            const isMinDateDataExist = this.roomList[0].dailySalesStatusList.some(dailySalesStatus => {
                return dailySalesStatus.salesDate == minDisplayDate;
            });
            const isMaxDateDataExist = this.roomList[0].dailySalesStatusList.some(dailySalesStatus => {
                return dailySalesStatus.salesDate == maxDisplayDate;
            });

            const isAllDisplayDaysRoomDataExist = isMinDateDataExist && isMaxDateDataExist;
            if (!isAllDisplayDaysRoomDataExist) {
                await this.findRoomList();
                this.sortRoomListByCurrentOrder();
            } else {
                this.filterSalesStatusList();
            }
        },
        formatDisplayDate(displayDate) { // 日にちを表示する形式に変換
            const date = moment(displayDate, 'YYYY-MM-DD');
            return date.format('M/D');
        },
        formatDisplayDayOfWeek(displayDate) { // 曜日を表示する形式に変換
            const date = moment(displayDate, 'YYYY-MM-DD');
            return DAY_OF_WEEK_MAP[date.day()];
        },
        getCheckInDateClass(salesDate) { //チェックイン日をマークアップ
            if (salesDate == this.searchConditions.checkInDate) {
                return 'checkInDate';
            }
        },
        getDaysClass(displayDate) { //日付表示の土日祝、チェックイン日を色付け
            const date = moment(displayDate, 'YYYY-MM-DD');
            const dayOfWeek = DAY_OF_WEEK_MAP[date.day()];

            if (displayDate in holidaysData) {
                if (displayDate == this.searchConditions.checkInDate) {
                    return 'holidayCheckInDate'
                }
                return 'holiday';
            }

            if (dayOfWeek == DAY_OF_WEEK_MAP[6]) {
                if (displayDate == this.searchConditions.checkInDate) {
                    return 'saturdayCheckInDate'
                }
                return 'saturday';
            }

            if (dayOfWeek == DAY_OF_WEEK_MAP[0]) {
                if (displayDate == this.searchConditions.checkInDate) {
                    return 'sundayCheckInDate'
                }
                return 'sunday';
            }

            if (displayDate == this.searchConditions.checkInDate) {
                return 'checkInDate';
            }
        },
        toRoomDetailPage(roomCode, salesStatus) { //部屋詳細ページを開く
            const parameters = new URLSearchParams();
            parameters.append('hotelCode', this.searchConditions.hotelCode);
            parameters.append('rmcd001', roomCode);
            parameters.append('pl', salesStatus.lowestPlanForMember ? salesStatus.lowestPlanForMember.planCode : salesStatus.lowestPlanForRegular.planCode);
            parameters.append('ci', moment(salesStatus.salesDate, 'YYYY-MM-DD').format('YYYYMMDD'));
            parameters.append('lt001', this.searchConditions.selectedLodgerType);
            parameters.append('lnum001', this.searchConditions.selectedLodgerCount);
            if (this.searchConditions.ghaLanding) {
                parameters.append('ghaLanding', this.searchConditions.ghaLanding);
            }
            const url = '/GSEA004F01600/GSEA004A01?' + parameters.toString() + '#anchor_calendar';
            window.location.href = url;
        },
        openRoomDetailModal(room) {
            this.eachRoomDetail = room;
            this.isRoomDetailModalOpened = true;

            this.$nextTick(() => {
                new Swiper(".mySwiper", {
                    spaceBetween: 30,
                    centeredSlides: true,
                    autoplay: {
                      delay: 2500,
                      disableOnInteraction: false,
                    },
                    pagination: {
                      el: ".swiper-pagination",
                      clickable: true,
                    },
                    loop: true,
                    loopAdditionalSlides: 1,
                });
            });
        },
        closeRoomDetailModal() {
            this.isRoomDetailModalOpened = false;
        },
        openGuestsSelectModal() {
            this.isGuestsSelectModalOpened = true;
        },
        closeGuestsSelectModal() {
            this.isGuestsSelectModalOpened = false;
        },
        addBrowserHistory() {
            // ブラウザ履歴追加
            const parameters = new URLSearchParams();
            parameters.append('hotelCode', this.searchConditions.hotelCode);
            if (this.searchConditions.checkInDate) {
                parameters.append('ci', moment(this.searchConditions.checkInDate, 'YYYY-MM-DD').format('YYYYMMDD'));
            }
            parameters.append('lt001', this.searchConditions.selectedLodgerType);
            parameters.append('lnum001', this.searchConditions.selectedLodgerCount);
            parameters.append('sortKeyOrder', SORT_MAP[this.searchConditions.sortKeyOrder]);
            if (this.searchConditions.ghaLanding) {
                parameters.append('ghaLanding', this.searchConditions.ghaLanding);
            }
            const browserUrl = location.pathname + '?' + parameters.toString();
            window.history.pushState({ url: browserUrl }, null, browserUrl);
        },
        convertHyperLink: common.convertHyperLink,
    },
}
